import api from "../../utils/api/api.utils";
import { appendQueryParams } from "../../utils/url.utils";
import { getEnabledAccountsCountPath, getEnabledAccountsPath, GENERATOR_PARAMS, } from "./enabledAccount.constants";
export var getEnabledAccounts = function (params) {
    var userId = params.userId, search = params.search;
    return api.get(appendQueryParams({
        path: getEnabledAccountsPath(userId),
        queryParams: { search: search },
    }), { isV2: true });
};
// Not the generated getCount: that one keys its cache on a query hash, while this count
// only ever varies by user id and takes no query at all.
export var getEnabledAccountsCount = function (params) {
    return api.get(getEnabledAccountsCountPath(params.userId), {
        isV2: true,
    });
};
export var addEnabledAccount = function (userId, enabledAccountId) {
    return api.post("/users/".concat(userId, "/").concat(GENERATOR_PARAMS.basePathEntity, "/").concat(enabledAccountId), { isV2: true });
};
export var removeEnabledAccount = function (userId, enabledAccountId) {
    return api.delete("/users/".concat(userId, "/").concat(GENERATOR_PARAMS.basePathEntity, "/").concat(enabledAccountId), { isV2: true });
};
export var useEnabledAccount = function (userId, enabledAccountId) {
    return api.post("/users/".concat(userId, "/").concat(GENERATOR_PARAMS.basePathEntity, "/").concat(enabledAccountId, "/use"), { isV2: true });
};
